/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2016, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./FilterBaseView',
	'../../widgets/livewidget/nls/StringResources'
],
function(View, StringResources) {
	'use strict';

	var HierarchicalFilterView = View.extend({
		reactViewClass: 'HierarchyFilter',
		compactReactViewClass: 'CompactHierarchyFilter',

		init: function() {
			HierarchicalFilterView.inherited('init', this, arguments);
			this.loading = false;
		},

		_getCommonViewProps: function() {
			var props = {
				title: this.model.getName(),
				actionTitle: StringResources.get('filter'),
				selectedValuesCount: this.model.getSelectedMembers().length,
				inverted: this.model.getInvert(),
				showSearch: true,
				locale: this.locale,
				showSubcaption: false,
				loading: this.loading
			};
			return props;
		},

		_getCommonViewCallbacks: function() {
			//TODO:
			this.callbacks = this.options;
			return {
				onClear: this._onClear.bind(this),
				onChange: this._onChange.bind(this),
				onClick: this._onClick.bind(this),
				onSearch: this._onSearch.bind(this),
				onDone: this._onDone.bind(this),
				onApply: this._onApply.bind(this),
				onClose: this._onClose.bind(this),
				onInvert: this.callbacks.cbOnInvert,
				onExpandCollapse: this.callbacks.cbOnExpandCollapse,
				onLoadMore:this.callbacks.cbOnLoadMore,
				getLimitChildren: this.callbacks.cbOnGetChildrenLimit,
				getValue: this.callbacks.cbGetValue,
				listOnClick: this.callbacks.cbListOnClick,
				listGetValue: this.callbacks.cbListGetValue,
				listOnInvert: this.callbacks.cbListOnInvert,
				onDoneSearch: this.callbacks.cbOnDoneSearch,
				getNumberOfChildren: this.callbacks.cbGetNumberOfChildren,
				listGetNumberOfChildren: this.callbacks.cbListGetNumberOfChildren
			};
		}
	});
	return HierarchicalFilterView;
});
